import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '../../common';
import { DirectivesModule } from '../../common/directives/directives.module';
import { ErrorType, PATTERN_TRANSLATION_KEY_MAP } from './field-error-messages.constant';
import { ValidationPatterns } from '../../modular-validation/validation';

type PatternKey = Extract<keyof ValidationPatterns, string>;

type ControlWithPatternKey = AbstractControl & {
  __patternKey?: PatternKey;
};

@Component({
  selector: 'ui-field-error-messages',
  imports: [CommonModule, TranslateModule, DirectivesModule],
  templateUrl: './field-error-messages.component.html',
  styleUrls: ['./field-error-messages.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class FieldErrorMessages {
  @Input() set control(c: UntypedFormControl | AbstractControl) {
    this.formControl = c;

    this.subscriptions.push(
      c.valueChanges.subscribe(() => {
        this.cd.detectChanges();
      }),
      c.statusChanges.subscribe(() => {
        this.cd.markForCheck();
      }),
    );
  }

  errorType = ErrorType;
  patternMessageMap = PATTERN_TRANSLATION_KEY_MAP;
  formControl: UntypedFormControl | AbstractControl;

  subscriptions: Subscription[] = [];

  constructor(private cd: ChangeDetectorRef) {}

  getPatternKeyFromAngularError(): string {
    const patternErr = this.formControl?.errors?.pattern;
    const requiredPattern = patternErr?.requiredPattern;

    const mapHit = requiredPattern ? this.patternMessageMap.get(requiredPattern) : undefined;

    const ctrl = this.formControl as ControlWithPatternKey;
    const localKey = ctrl.__patternKey;

    // fallback chain
    return localKey ?? mapHit ?? 'default';
  }
}
